const jobTitles = [
  'Teacher',
  'Superintendent',
  'School or District Administrator',
  'Tech Admin / IT Director',
  'Student Safety / Health Services',
  'Curriculum and Instruction',
  'Consultant',
  'Counselor',
  'Librarian or Media Specialist',
  'Parent / Caregiver',
  'Student',
  'Other',
];

export default jobTitles.map((t) => ({ label: t, value: t }));



/** WEBPACK FOOTER **
 ** ./src/_shared/lib/job-titles/index.js
 **/